/** Code shown on the docs page. Code isn't translated; the text around it is. */

export const AUTH_HEADERS = `# OpenAI style
Authorization: Bearer lcr_your_key

# Anthropic style
x-api-key: lcr_your_key

# Gemini style (or ?key=lcr_your_key in the URL)
x-goog-api-key: lcr_your_key`;

export const OPENAI_STREAM = `curl https://api.lowcostrouter.com/v1/chat/completions \\
  -H "Authorization: Bearer $LOWCOSTROUTER_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gpt-6-sol",
    "stream": true,
    "stream_options": {"include_usage": true},
    "messages": [{"role": "user", "content": "Hello!"}]
  }'`;

export const ANTHROPIC_REQUEST = `curl https://api.lowcostrouter.com/v1/messages \\
  -H "x-api-key: $LOWCOSTROUTER_API_KEY" \\
  -H "anthropic-version: 2023-06-01" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "claude-sonnet-5-5",
    "max_tokens": 1024,
    "messages": [{"role": "user", "content": "Hello!"}]
  }'`;

export const GEMINI_STREAM = `curl "https://api.lowcostrouter.com/v1beta/models/gemini-3.8-flash:streamGenerateContent?alt=sse" \\
  -H "x-goog-api-key: $LOWCOSTROUTER_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{"contents": [{"parts": [{"text": "Hello!"}]}]}'`;

export const ENV_VARS = `# OpenAI SDKs and tools built on them
export OPENAI_BASE_URL=https://api.lowcostrouter.com/v1
export OPENAI_API_KEY=lcr_your_key

# Anthropic SDKs and tools built on them
export ANTHROPIC_BASE_URL=https://api.lowcostrouter.com
export ANTHROPIC_API_KEY=lcr_your_key`;

export const ERROR_EXAMPLE = `HTTP/1.1 402 Payment Required

{
  "error": {
    "message": "Insufficient balance. Top up at https://lowcostrouter.com/app/billing",
    "type": "insufficient_quota",
    "code": null
  }
}`;
